import { CHEGG, BIBME, CITATION_MACHINE, EASYBIB } from '../types'
import { CHEGG_PRODUCT, CITATION_MACHINE_PRODUCT, BIBME_PRODUCT, EASYBIB_PRODUCT, ProductMap } from '../analytics/types'

export const productMap: ProductMap = {
  [CHEGG]: CHEGG_PRODUCT,
  [BIBME]: BIBME_PRODUCT,
  [CITATION_MACHINE]: CITATION_MACHINE_PRODUCT,
  [EASYBIB]: EASYBIB_PRODUCT,
}
